import type { ShortCircuitScenarioResults } from '../../..';
import { filterOnlyCalculatedMvBusbarResults } from '../../../filterOnlyMvBusbarResults';
import type { FunctionalGrid } from '../../../grid/FunctionalGrid';
import type { ForFaultsEvaluation } from '../ForFaultsEvaluation';
import { GridElementsSummaryEvaluation } from './evaluateGridElements';

export const evaluateBusbars = (
  scenarios: ShortCircuitScenarioResults[],
  evaluationEngine: ForFaultsEvaluation,
  functionalGrid: FunctionalGrid
) => {
  const busbarResults = scenarios.flatMap(scenario =>
    scenario.results.filter(
      elementResult => elementResult.objectType === 'Busbar'
    )
  );
  const resultsIncludingOnlyMvBusbars = filterOnlyCalculatedMvBusbarResults(
    busbarResults,
    functionalGrid
  );

  return GridElementsSummaryEvaluation.fromResults(
    resultsIncludingOnlyMvBusbars,
    'Busbar'
  ).evaluate(evaluationEngine);
};
